module.exports = __webpack_public_path__ + "images/cc9c5aa53622e89fb913f0e3924bb948-Tourism Ireland.jpg";